import Index from "../views/professionalProfile/Index.vue";
import PaymentMethod from "../views/professionalProfile/PaymentMethod.vue";
import Insurance from "../views/professionalProfile/Insurance.vue";
import CancelingPolicy from "../views/professionalProfile/CancelingPolicy.vue";
import PreSignin from "../views/professionalProfile/PreSignin.vue";
import Login from "../views/professionalProfile/Login.vue";
import Register from "../views/professionalProfile/Register.vue";
import Patient from "../views/professionalProfile/Patient.vue";
import Payment from "../views/professionalProfile/Payment.vue";
import Pix from "../views/professionalProfile/Pix.vue";
import Scheduled from "../views/professionalProfile/Scheduled.vue";
import PixFail from "../views/professionalProfile/PixFail.vue";

const meta = {
    auth: false,
    scheduling: true,
    layout: 'guest-layout',
};

export default [
    { path: '/professional/:professionalId', name: 'ProfessionalProfileIndex', component: Index, meta },
    { path: '/professional/:professionalId/payment-methods', name: 'ProfessionalProfilePaymentMethod', component: PaymentMethod, meta },
    { path: '/professional/:professionalId/insurances', name: 'ProfessionalProfileInsurance', component: Insurance, meta },
    { path: '/professional/:professionalId/canceling-policies', name: 'ProfessionalProfileCancelingPolicy', component: CancelingPolicy, meta },
    { path: '/professional/:professionalId/pre-signin', name: 'ProfessionalProfilePreSignin', component: PreSignin, meta },
    { path: '/professional/:professionalId/login', name: 'ProfessionalProfileLogin', component: Login, meta },
    { path: '/professional/:professionalId/register', name: 'ProfessionalProfileRegister', component: Register, meta },
    { path: '/professional/:professionalId/patients', name: 'ProfessionalProfilePatient', component: Patient, meta },
    { path: '/professional/:professionalId/payment', name: 'ProfessionalProfilePayment', component: Payment, meta },
    { path: '/professional/:professionalId/pix', name: 'ProfessionalProfilePix', component: Pix, meta },
    { path: '/professional/:professionalId/scheduled', name: 'ProfessionalProfileScheduled', component: Scheduled, meta },
    { path: '/professional/:professionalId/pix-fail', name: 'ProfessionalProfilePixFail', component: PixFail, meta },
];
